import React from 'react'
import Navbar from '../components/Navbar'
import Movies from '../components/Movies'

const Moviespage = () => {
  return (
    <>
      <Navbar/>
      <Movies/>
    </>
  )
}

export default Moviespage
